/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentProcessingReceiptIntakeReason =
    (typeof DocumentProcessingReceiptIntakeReason)[keyof typeof DocumentProcessingReceiptIntakeReason];

export const DocumentProcessingReceiptIntakeReason = {
    ExistingDuplicate: 'ExistingDuplicate',
    BatchDuplicate: 'BatchDuplicate',
    MissingFileKey: 'MissingFileKey',
    MissingFileName: 'MissingFileName',
    EmptyFile: 'EmptyFile',
    MissingFileExtension: 'MissingFileExtension',
    UnsupportedFileType: 'UnsupportedFileType',
    SourceFileTooLarge: 'SourceFileTooLarge',
    ArchiveTooLarge: 'ArchiveTooLarge',
    ArchiveEntryTooLarge: 'ArchiveEntryTooLarge',
    ExtractionLimitExceeded: 'ExtractionLimitExceeded',
    InvalidFile: 'InvalidFile',
    ImportFailed: 'ImportFailed',
    Blocked: 'Blocked',
} as const;
